module.exports = __webpack_public_path__ + "img/athena_carousel_13.ebe5bb9a.jpg";